import { memo } from 'react'
import TimeAgo from 'timeago-react'
import CardFooterItem from './CardFooter/CardFooterItem'

interface PublishDateProps {
  date?: Date | string
  tooltip?: boolean
  ownerAvatar?: JSX.Element | null
}

function PublishDate({ date, tooltip = true, ownerAvatar }: PublishDateProps) {
  if (!date) return null

  return (
    <CardFooterItem
      text={<TimeAgo opts={{ minInterval: 60 }} datetime={date} />}
      icon={ownerAvatar}
      tooltip={tooltip}
      tooltipText={true}
      tooltipTextLabelId={'common.cards.lastUpdatedTooltip'}
    />
  )
}

export default memo(PublishDate)
